import PropTypes from "prop-types";
import React from "react";
import { Modal, Button } from "react-bootstrap";

const LogoutModal = ({ show, onClose, onConfirm, logoPath }) => (
  <Modal show={show} onHide={onClose} centered className="logout-modal">
    <Modal.Body className="text-center">
      <div className="d-flex justify-content-center w-100 mb-3">
        <img
          src={logoPath}
          alt="VLUp"
          style={{ height: '83px' }}
        />
      </div>
      <p>Are you sure you want to logout account?</p>
    </Modal.Body>
    <Modal.Footer className="justify-content-center border-0 p-0">
      <Button variant="outline-secondary" onClick={onClose}>
        No
      </Button>
      <Button className="btn loginsubmit outline" onClick={onConfirm}>
        Yes
      </Button>
    </Modal.Footer>
  </Modal>
);

// PropTypes for the LogoutModal component
LogoutModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  logoPath: PropTypes.string.isRequired,
};

export default LogoutModal;
